import { render, staticRenderFns } from "./SquadbeyondInputs.vue?vue&type=template&id=573e7af7&scoped=true"
import script from "./SquadbeyondInputs.vue?vue&type=script&lang=js"
export * from "./SquadbeyondInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573e7af7",
  null
  
)

export default component.exports